<template>
  <v-app id="good3">
    <v-content :style="backgroundImageStyle">
      <v-container fluid fill-height no-gutters>
        <v-row align="center" justify="center">
          <v-col cols="12" align="center">
            <v-row align="center" justify="center">
              <v-col id="good3_loginBox" cols="10" sm="6" lg="4" xl="3" class="py-4 elevation-3">
                <v-row align="center" justify="center">
                  <v-col class="pb-3 display-1 font-weight-light">
                    Who are you, friend?
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="8" class="body-1">
                    <v-text-field
                      color="yellow"
                      background-color="grey darken-3"
                      label="email"
                      v-model="inputEmail"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col cols="8" class="body-1">
                    <v-text-field
                      color="accent"
                      background-color="grey darken-3"
                      type="password"
                      label="password"
                      v-model="inputPassword"
                    ></v-text-field>
                  </v-col>
                </v-row>
                <v-row align="center" justify="center">
                  <v-col class="body-1">
                    <v-btn
                      class="ma-0 my-2"
                      color="yellow"
                      light
                      :loading="loginRequestLoading"
                      @click="doLogin"
                    >let me in</v-btn>
                    <v-alert
                      class="mt-3"
                      :value="outputAlert"
                      type="error"
                      transition="scale-transition"
                    >
                      {{ outputMessage }}
                    </v-alert>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-card id="good3_quote" flat align="left" class="d-inline-block display-2 font-weight-light font-italic transparent pt-8">
              &ldquo;&nbsp;I'm not your friend, buddy!&nbsp;&rdquo;<br>
              <span class="title font-weight-light">&mdash; Terrance &amp; Phillip</span>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from 'axios'

// MIXINS
import { Good3Lib } from '../good3lib/good3_lib'

// DEFAULT
export default {
  name: 'GOOD3',

  // Importing VUEJS shared resources
  //
  // • props for input
  // • components for sub vue components
  // • mixins for methods libraries
  props: {},
  components: {},
  mixins: [Good3Lib],

  // Accessible properties
  //
  // • data
  // • computed
  // • watch
  data: () => ({
    backgroundImageStyle: {
      'background-image': 'url(' + require('../assets/wall_old_tristram.jpg') + ')',
      // 'background-image': 'url(' + require('../assets/wall_sea.jpg') + ')',
      'background-size': 'cover',
      'background-position': 'center center',
      'background-repeat': 'no-repeat',
      'background-color': 'grey darken-3',
      'background-attachment': 'fixed'
    },
    loginRequestLoading: false,
    inputEmail: '',
    inputPassword: '',
    outputAlert: false,
    outputMessage: ''
  }),
  methods: {
    // doLogin grab the credentials from the form and call the backend to login
    // the result is handled by the proc handleLoginCall
    doLogin () {
      // we first disable the button
      this.loginRequestLoading = true

      // reset the alert
      this.outputAlert = false

      // calling GOOD3 for login
      axios.post(this.helpMeBackendURLForPath('good3?action=login'),
        {
          version: '1.0',
          name: 'login',
          username: this.inputEmail,
          password: this.inputPassword
        }
      )
        .then(response => {
          this.handleLoginCall(response)
        })
        .catch(error => {
          this.loginRequestLoading = false
          this.outputMessage = 'Back-end cannot be reached, this is sad news!'
          this.outputAlert = true
          console.log(error)
        })
    },
    // handleLoginCall verifies that there was no error at the HTTP layer and no
    // error at the application layer then store the current user to log the
    // user in
    handleLoginCall (pResponse) {
      // basic sanity check
      if (!pResponse) {
        this.loginRequestLoading = false
        this.outputMessage = 'Back-end cannot be reached, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the HTTP layer
      if (pResponse.status !== 200) {
        this.loginRequestLoading = false
        this.outputMessage = 'Back-end forbids our calls, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the application layer
      if (!pResponse.data) {
        this.loginRequestLoading = false
        this.outputMessage = 'Back-end failed processing our request, this is sad news!'
        this.outputAlert = true
        return
      }

      // checking the application layer. if the application server tells us the
      // authentication failed we catch the specific code.
      if (pResponse.data.error) {
        switch (pResponse.data.error.code) {
          case 'GOOD3_AUTHENTICATION_FAILED':
            this.outputMessage = 'Authentication failed!'
            break
          default:
            this.outputMessage = 'Back-end failed processing our request, this is sad news!'
        }

        this.loginRequestLoading = false
        this.outputAlert = true

        // stopping here since there was an application error
        return
      }

      if (!pResponse.data.data) {
        this.outputMessage = 'Back-end did not send your identity back, this is sad news!'
        this.loginRequestLoading = false
        this.outputAlert = true
        return
      }

      // we have the user object into pResponse.data.data
      var vCurrentUser = pResponse.data.data
      this.$store.commit('logUserIn', vCurrentUser)
    }
  }
}
</script>

<style scoped>
#good3_loginBox {
  background-color: #424242dd
}

</style>
